import {stateData, reduxState} from '../../values';

export const getReports = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_reports,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateReports = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_reports,
            payload:    data,
        })
    }
}